"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvertInteractiveBorderColors = exports.InteractiveBorderColors = exports.TextFieldHoverColor = exports.InvertBorderColors = exports.InvertTextColors = exports.TextFieldBorderColors = exports.ListAndMenuColors = exports.TextColors = void 0;
exports.TextColors = {
    Primary: '#2e2e2e',
    Neutral: '#5c5c5c',
    Disabled: '#c9c9c9',
    Error: '#ba0517',
    Valid: '#22683e',
};
// Content of a list item is customer controlled (and it's not necessarily just text).
// The expectation for disabled items is that everything (including icons) looks "grayed out".
// To achieve this automatically (without the customer having to gray it out themselves),
// opacity is added to disabled items. Thus the grays used for disabled items have to be adjusted
// so that they render as the spec'd color with the opacity.
exports.ListAndMenuColors = {
    Active: '#e5e5e5',
    ActiveBorder: '#939393',
    DisabledBorder: '#040404',
    DisabledText: '#c9c9c9',
    DisabledTextWithOpacity: '#828282',
    Hover: '#e5e5e5',
    Opacity: 0.43,
    Press: '#c9c9c9',
    Text: '#444444', // 68
};
exports.TextFieldBorderColors = {
    Rest: '#747474',
    Disabled: '#c9c9c9',
    Error: '#ba0517',
    Valid: '#22683e',
};
exports.InvertTextColors = {
    Primary: '#fff',
    Secondary: 'rgba(255, 255, 255, 0.96)',
    Netural: 'rgba(255, 255, 255, 0.56)',
    Disabled: 'rgba(255, 255, 255, 0.35)',
};
exports.InvertBorderColors = {
    Rest: '#aeaeae',
    Disabled: '#747474', // component/content/outline/on-dark/disabled
};
exports.TextFieldHoverColor = '#e5e5e5';
exports.InteractiveBorderColors = Object.freeze({
    borderColor: exports.TextFieldBorderColors.Rest,
    $nest: {
        '&:disabled': { borderColor: "" + exports.TextFieldBorderColors.Disabled },
    }
});
exports.InvertInteractiveBorderColors = Object.freeze({
    borderColor: exports.InvertBorderColors.Rest,
    $nest: {
        '&:disabled': { borderColor: "" + exports.InvertBorderColors.Disabled },
    }
});
//# sourceMappingURL=Colors.js.map